import CatalogoFamilia from "../catalogoFamilia/catalogoFamilia";
import "./detallesInstalaciones.scss";

export default function DetallesInstalaciones() {
    return (
        <CatalogoFamilia
            title="Detalles instalaciones"
            className="detalles-instalaciones"
            codFamilia={11}
        />
    );
}
